import type { QueryClient } from "@tanstack/react-query";

/**
 * Startet eine Abfrage bereits im Router-Loader, also während der Seitencode
 * noch geladen wird. Die Komponente nutzt denselben Schlüssel und übernimmt
 * das laufende Ergebnis – es entsteht kein zweiter Abruf.
 *
 * Bewusst ohne `await`: der Seitenwechsel soll nicht auf die Daten warten,
 * die Seite zeigt weiterhin ihren eigenen Ladezustand.
 *
 * Läuft nur im Browser. Auf dem Server (SSR/Vorab-Erzeugung) gibt es keine
 * angemeldete Sitzung, deshalb wird dort nichts angestoßen.
 */
export function warmAdminQuery<T>(
  queryClient: QueryClient,
  input: { queryKey: readonly unknown[]; queryFn: () => Promise<T>; staleTime?: number },
): void {
  if (typeof window === "undefined") return;
  void queryClient
    .prefetchQuery({
      queryKey: input.queryKey,
      queryFn: input.queryFn,
      staleTime: input.staleTime ?? 30_000,
    })
    .catch(() => {
      // Fehler behandelt die Komponente über ihre eigene Abfrage.
    });
}
